<template>
  <b-button v-bind="$attrs" @click.prevent="clicked()" :disabled="disabled" >
    <b-form-checkbox v-bind:checked="checked">{{ text }}</b-form-checkbox>
  </b-button>
</template>



<script>
  import { BButton, BFormCheckbox } from 'bootstrap-vue';

  export default ({
    data () {
      return {
        checked: false
      }
    },

    mounted () {
      this.checked = this.value;
    },

    computed : {
      isChecked() {
        return this.checked;
      }
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        required: false
      }
    },

    methods: {
      clicked () {
        this.$emit('click')
        this.checked = !this.checked
      }
    },

    watch: {
      value(new_val, old_val) {
        this.checked = new_val;
      },
      isChecked(new_val, old_val) {
        this.$emit('input', new_val)
      }
    },

    components: {
      BButton,
      BFormCheckbox
    }
  })
</script>



// WEBPACK FOOTER //
// ButtonCheckbox.vue?3a6412d6